const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0]!.toUpperCase())
    .join('')
    .slice(0, 2);

export function Avatar({
  name,
  photoUrl,
  colour,
  size = 'md',
}: {
  name: string;
  photoUrl?: string | null;
  colour?: string;
  size?: 'sm' | 'md' | 'xl';
}) {
  return (
    <span
      className={`avatar${size !== 'md' ? ` avatar--${size}` : ''}`}
      style={colour ? { ['--av' as string]: colour } : undefined}
      aria-hidden="true"
    >
      {photoUrl ? <img src={photoUrl} alt="" loading="lazy" /> : initials(name)}
    </span>
  );
}

/**
 * Part picture: the uploaded photo, else a tile with the part's initials — so a card is
 * recognisable at a glance even before anyone adds a photo.
 */
export function PartThumb({
  name,
  photoUrl,
  size = 52,
}: {
  name: string;
  photoUrl?: string | null;
  size?: number;
}) {
  if (photoUrl) {
    return (
      <span className="thumb" style={{ width: size, height: size }}>
        <img src={photoUrl} alt="" loading="lazy" width={size} height={size} />
      </span>
    );
  }
  return (
    <span
      className="thumb thumb--initials"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}
